import * as React from "react";
import styled from "styled-components";
import { v4 as uuid } from "uuid";

import { Icon } from "src/library/components/Icon";
import { Text } from "src/library/components/Text";
import { Tooltip } from "src/library/components/Tooltip";
import { Colors } from "src/library/utils/theme";
import { Icons } from "src/library/components/Icon/types";
import {
  IOrderStatus,
  OrderStatusGroupType
} from "src/core/orders/api/orders.api";

interface IProps {
  status?: IOrderStatus;
  orderId: number;
  tooltipPlace: "top" | "bottom" | "left" | "right";
}

interface IStatusWrapper {
  status?: OrderStatusGroupType;
}

const StatusWrapper = styled("span")<IStatusWrapper>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  
  .status-code {
    text-transform: capitalize;
    color: ${({ status, theme }) => {
    if (!status) {
      return "inherit";
    }
    const orderStatusColorKey = `${status.toLowerCase()}Order` as keyof Colors;

    return theme.colors[ orderStatusColorKey ];
  }};
  }

  .help-icon {
    cursor: help;
    display: inline;
    margin-left: 5px;
  }
`;

/**
 * Gets the order status
 */
const OrderStatus = ({
  status, tooltipPlace, orderId
}: IProps) => {
  if (status) {
    const tippyKey = `orderStatus-${orderId}-${uuid()}`;

    return (
      <StatusWrapper status={status.settings.group}>
        {status.description && (
          <Tooltip
            id={tippyKey}
            type="dark"
            place={tooltipPlace}
            disable={status.description === null}
            getContent={() => {
              return (
                <Text color="white">
                  {status.description}
                </Text>
              );
            }}
          />
        )}

        <Text
          weight="bold"
          className="status-code"
        >
          {status.name}
        </Text>

        {status.description && (
          <div
            className="help-icon"
            data-tip
            data-for={tippyKey}
          >
            <Icon
              icon={Icons.HELP}
              size={10}
            />
          </div>
        )}
      </StatusWrapper>
    );
  }

  return (
    <StatusWrapper>
      -
    </StatusWrapper>
  );
};

export default OrderStatus;
